import { render, staticRenderFns } from "./bpreport.vue?vue&type=template&id=ec59c372&"
import script from "./bpreport.vue?vue&type=script&lang=js&"
export * from "./bpreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports